export enum VideoUploadsFilterField {
	Source = "source",
	VeoCameraId = "veoCameraId",
	VeoClubhouse = "veoClubhouse",
	VeoTeam = "veoTeam",
	CreatedAt = "createdAt",
	UploadedBy = "uploadedBy",
	SavedBy = "savedBy",
	ApiStatus = "apiStatus",
	GameId = "gameId",
}

export enum VideoUploadsSourceFilterValue {
	All = "",
	Manual = "manual",
	ApiDieLigen = "api-die-ligen",
	ApiVeo = "api-veo",
	Discover = "discover",
}
